<template>
  <div
    class='theme-autocomplete__field-holder'
    :class="{
      'theme-input__field-holder--error': !!errors.has(newName),
      'theme-input__field-holder--focused': isFocused,
    }"
    data-vv-value-path='model'
    :data-vv-as='label'
  >
    <label class='theme-input__label' v-if='showLabel && labelHtml' v-html='labelHtml'></label>
    <label class='theme-input__label' v-else-if='showLabel && label'>
      {{ label }}
      <span v-if='isRequired' class='theme-input__label-asterisk'>*</span>
    </label>

    <div class='theme-autocomplete'>
      <div class='theme-autocomplete__input-wrapper'>
        <input type='hidden' :name='name' :value='model' :rules='rules'/>
        <input
          class='theme-input pr-20'
          :class="{'bg-[#2EC3FF] border-none pl-0 placeholder:text-black': blue}"
          v-model='phrase'
          type='text'
          :name='`_labels[${name}]`'
          autocomplete='off'
          :placeholder="placeholder"
          @keyup='suggest'
          @keydown='clearTimeout'
          @keydown.enter.prevent
          @focus='
          showList = true;
          isFocused = true;
        '
          :disabled='disabled'
          @blur='
          blur();
          isFocused = false;
        '
        />

        <span v-if="phrase" @click="clearPhrase" class="icon-clear theme-autocomplete__icon-clear"></span>
        <span v-if="errors.has(newName)" class="icon-warning theme-input__icon theme-input__icon-error theme-autocomplete__icon-error"></span>
      </div>
      <ul class='theme-autocomplete__list' v-if='showList && suggestions.length'>
        <li
          v-for='item in suggestions'
          class='theme-autocomplete__item'
          :class="{ 'theme-autocomplete__item--is-selected': item === selected }"
          :key='item.id'
          @click='pick(item)'
        >
          {{ resolve(item) }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';
  import field from '../admin/mixins/field';
  import $ from 'jquery';

  export default {
    props: {
      placeholder: {
        default: null,
        type: String
      },
      value: {
        default() {
          return [];
        },
      },
      resolve: {
        default: (hit) => {
          return hit.name;
        },
        type: Function,
      },
      endpoint: {
        default: '/admin/autocomplete/locations',
        type: String,
      },
      base: {
        default: '',
        type: String,
      },
      initial: {
        default: '',
        type: String,
      },
      showLabel: {
        default: true,
        type: Boolean,
      },
      isRequired: {
        default: false,
        type: Boolean,
      },
      labelHtml: {
        default() {
          return '';
        },
        type: String,
      },
      blue: {
        default: false,
        type: Boolean,
      }
    },
    data() {
      return {
        isDirtyData: null,
        showList: false,
        suggestions: [],
        selected: null,
        phrase: this.initial,
        typingTimer: null,
        doneTypingInterval: 700,
        isFocused: false,
      };
    },
    methods: {
      suggest(event) {
        let keyCode = event.keyCode;

        switch (keyCode) {
          case 38:
            if (_.indexOf(this.suggestions, this.selected) === 0) {
              this.selected = this.suggestions[this.suggestions.length - 1];
            } else {
              this.selected = this.suggestions[
              _.indexOf(this.suggestions, this.selected) - 1
                ];
            }

            break;
          case 40:
            if (
              _.indexOf(this.suggestions, this.selected) ===
              this.suggestions.length - 1
            ) {
              this.selected = this.suggestions[0];
            } else {
              this.selected = this.suggestions[
              _.indexOf(this.suggestions, this.selected) + 1
                ];
            }

            break;
          case 13:
            this.pick(this.selected);

            break;
          case 9:
            break;
          default:
            this.typing();
            break;
        }
      },
      pick(item) {
        this.phrase = this.resolve(item);
        this.showList = false;
        this.model = item.id;
        this.selected = null;
        this.isDirtyData = false;
      },
      typing() {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.doneTyping, this.doneTypingInterval);

        this.showList = true;
        this.model = this.phrase;
        this.isDirtyData = true;
      },
      clearTimeout() {
        clearTimeout(this.typingTimer);
      },
      doneTyping() {
        $.get(this.endpoint + '?q=' + this.phrase).then((response) => {
          this.suggestions = response;
        });
      },
      blur() {
        setTimeout(() => {
          this.showList = false;
        }, 300);
      },
      changePhrase(value) {
        this.phrase = value;
      },
      clearPhrase() {
        this.phrase = '';
        this.model = '';
      }
    },
    mixins: [field],
    watch: {
      model(value) {
        if (!value) {
          this.phrase = null;
        }
        this.$emit('update', value);
        this.$emit('input', value);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/ThemeAutocomplete.vue